import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { ButtonLink } from './ui/Button';
import { SectionReveal } from './ui/SectionReveal';
import { ledgerStats } from '../data/record';
import { WAYDEV_CONTACT_URL } from '../data/contact';
export function Hero() {
  const reduce = useReducedMotion();
  return <section className="mx-auto max-w-shell px-[clamp(20px,5vw,64px)] pb-[clamp(40px,5vw,60px)] pt-[clamp(32px,4vw,56px)]" data-id="element-70" data-mp="4n1lcrjx0csi">
      <motion.div initial={reduce ? false : {
      opacity: 0,
      y: 12
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.3,
      ease: [0.2, 0, 0, 1]
    }} data-id="element-71" data-mp="128pgza8jqr2z">
        <p className="font-mono text-[11px] uppercase tracking-[0.14em] text-ink-45" data-id="element-72" data-mp="s9q6rn84undv">
          San Francisco &amp; New York
          <span className="px-2 text-rule" data-id="element-73" data-mp="neazje4mrpqf">/</span>
          Building engineering measurement since 2017
        </p>

        <h1 className="mt-5 max-w-[16ch] font-serif text-[clamp(38px,6.4vw,74px)] font-medium leading-[1.08] tracking-[-0.02em]" data-id="element-74" data-mp="382ffxqfwf8fz">
          Nine years of measuring how software actually gets built.
        </h1>

        <p className="mt-[26px] max-w-[56ch] text-[clamp(16.5px,1.5vw,18.5px)] leading-[1.62] text-ink-70" data-id="element-75" data-mp="3o85blc7uc353">
          I am Alex Circei, co-founder and CEO of Waydev. I work with
          engineering leaders at large organizations on a single question that
          is getting harder to answer every quarter: what is your AI investment
          actually returning, and can you prove it to a board?
        </p>

        <div className="mt-[34px] flex flex-wrap items-center gap-3" data-id="element-76" data-mp="358zp26ngt5ie">
          <ButtonLink href={WAYDEV_CONTACT_URL} target="_blank" rel="noopener noreferrer" data-id="element-77" data-mp="2qjv9yybyvhei">
            Enquire about an engagement
          </ButtonLink>
          <ButtonLink variant="ghost" href="#index" data-id="element-78" data-mp="2hj5i25ptub62">
            Read the archive
          </ButtonLink>
        </div>

        <p className="mt-5 font-mono text-[11px] uppercase tracking-[0.12em] text-ink-45" data-id="element-79" data-mp="2lla9cxssyvpj">
          By enquiry only
          <span className="px-2 text-rule" data-id="element-80" data-mp="s333380kgeuw">/</span>
          A small number of engagements each year
        </p>
      </motion.div>

      <dl className="mt-[clamp(48px,7vw,84px)] grid grid-cols-2 border-t border-ink md:grid-cols-4" data-id="element-81" data-mp="na060pwkyn9y">
        {ledgerStats.map((stat, i) => <SectionReveal key={stat.label} delay={i * 0.04} className="border-b border-rule-soft py-5 pr-4 [&:nth-last-child(-n+2)]:border-b-0 md:border-b-0 md:border-r md:border-rule-soft md:pr-[22px] md:last:border-r-0" data-id="element-82" data-mp="ddnfu208urjy" data-mpi={i}>
            <dt className="sr-only" data-id="element-83" data-mp="15zzvhdwc24dw">{stat.label}</dt>
            <dd data-id="element-84" data-mp="111ogypv3f5pc">
              <b className="block font-serif text-[clamp(24px,3vw,34px)] font-medium leading-none tracking-[-0.02em]" data-id="element-85" data-mp="11154hoo7p9ip">
                {stat.value}
              </b>
              <span className="mt-[9px] block max-w-[20ch] font-mono text-[11px] uppercase leading-[1.5] tracking-[0.14em] text-ink-45" data-id="element-86" data-mp="3lt75kr1phru9">
                {stat.label}
              </span>
            </dd>
          </SectionReveal>)}
      </dl>
    </section>;
}